import { Link } from "react-router-dom"
import style from "./menu.module.scss"

export const Menu = ()=>{
    return <div className={style.menuContainer}>
        <div className={style.menuItem}><Link to="/">Home</Link></div>
        <div className={style.menuItem}><Link to="/contacts">Contacts</Link></div>
    </div>
}